import styled from "styled-components";
import { Dialog } from "@material-ui/core";
import { COLORS } from "Styles/Constants";

export const DialogWrapper = styled(Dialog)`
	.MuiBackdrop-root {
		background-color: rgba(0, 0, 0, 0.8);
	}

	.MuiDialog-paper {
		background: transparent;
		color: #fff;
		overflow: visible;
	}

	.box {
		min-width: 600px;

		h1,
		h2,
		h3,
		h4,
		h5,
		h6 {
			color: #ffffff;
		}

		h1 {
			font-size: 56px;
		}

		h2 {
			font-size: 42px;
		}

		h3 {
			font-size: 32px;
		}

		h4 {
			font-size: 24px;
		}

		.title-container {
			position: relative;
			.title {
				margin-bottom: 10px;
			}

			.sub-title {
				font-size: 22px;
				margin-top: 10px;
			}

			.icon-container {
				cursor: pointer;
				position: absolute;
				right: 23px;
				top: 0px;
				z-index: 2;

				.icon {
					color: ${COLORS.SECONDARY};
					font-size: 35px;
				}
			}
		}

		.content-wrapper {
			padding: 10px 10px 35px;
			position: relative;

			.scroll-bar {
				.thumb-vertical {
					background-color: rgba(66, 222, 251, 0.5);
					border-radius: 5px;
				}

				.track-vertical {
					background-color: transparent !important;
					right: 2px;
					top: 0;
					bottom: 0;
					border-radius: 3px;
					width: 6px !important;
				}

				.track-horizontal,
				.thumb-horizontal {
					display: none !important;
					height: 0 !important;
					width: 0 !important;
				}
			}

			.content {
				padding-right: 10px;
				color: #fff;

				*,
				*::before,
				*::after {
					border-color: transparent !important;
					color: #fff !important;
				}
			}

			.attach-file {
				display: flex;
				justify-content: center;

				.icon {
					color: #fff;
				}

				.file {
					margin: 0px 10px;
					font-size: 18px;
					cursor: pointer;
					text-decoration: underline;
					color: #fff;
				}

				.pdf-loader {
					width: 20px !important;
					height: 20px !important;
					color: #fff;
					margin-top: 1px;
				}
			}

			.progress {
				position: absolute;
				top: 36%;
				left: 0;
				right: 0;
			}

			.type-switcher {
				.divider {
					background-color: ${COLORS.SECONDARY};
					height: 2px;
					width: 50%;
					margin: 5px auto;
					opacity: 0.5;
				}

				.text {
					color: ${COLORS.SECONDARY};
					cursor: pointer;
					transition: 0.3s;
					&:hover {
						color: #fff;
					}
				}
			}
		}
	}
	.button-wrapper {
		margin-top: -25px;
		text-align: center;

		.styled {
			min-width: 185px;
		}
	}
`;
